export class ConnectSourceAwsOrganizationalUnitRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerOrganizationalUnitId",
            "baseName": "providerOrganizationalUnitId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectSourceAwsOrganizationalUnitRequest.attributeTypeMap;
    }
    constructor() {
    }
}
